import Vue from 'vue';
import axios from 'axios';
import InfiniteLoading from 'vue-infinite-loading';
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);
Vue.use(InfiniteLoading, {});

Vue.config.productionTip = process.env.NODE_ENV === 'production';

import Notifications from './components/Notifications.vue';
Vue.component('Notifications', Notifications);

new Vue({
    el: '#notifications',
    name: 'notifications',
});

